<template>
  <div class="d-flex flex-column" style="gap: 5px;">
    <div class="text-caption text-uppercase font-weight-medium grey--text">
      {{ label }}
    </div>
    <v-select
      :value="value"
      :items="items"
      outlined
      rounded
      dense
      hide-details
      class="v-select-mini"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: "a-pricing-strategy-rule-type-condition-field-select",
  props: {
    value: { default: null },
    items: { type: Array, default: () => [] },
    label: { type: String, default: "" }
  }
};
</script>
